module.exports = __webpack_public_path__ + "static/media/rightArrowCalendar.36f5137a.svg";